module.exports = {"id":"207877","name":"Josef Martínez","rating":"78","photo":"./data/images/photos/3/207877.png","club":{"name":"Atlanta United FC","logo":"./data/images/clubs/AtlantaUnitedFC.png"},"positions":["BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JosefMartinez0.json
// module id = 2184
// module chunks = 0